
<q-td
  v-if="!mobile"
  key="domain"
  :props="props"
  class="cmp-domain-title ws-text-primary"
>
  <div class="wrapper">
    <ws-badge
      v-if="percentageDiscount && domain.availableForPurchase"
      tertiary
      class="discount-badge"
    >
      <small><strong>{{ percentageDiscount }}</strong></small>
    </ws-badge>
    <span class="domain-name q-mr-md">{{ domain.name | rmTld(domain.tld)
    }}<span class="tld text-bold">.{{ domain.tld }} </span></span>
    <caption
      v-if="showOccupied"
      class="text-occupied text-uppercase text-right q-mr-md"
    >
      {{
        $t('domain_checker.occupied.short_status')
      }}
    </caption>
    <premium-badge
      v-else-if="domain.premium"
      :class="{ dark: inCart }"
      class="q-mr-md"
    />
  </div>
</q-td>
<!-- MOBILE VIEW -->
<div v-else class="cmp-domain-title">
  <premium-badge v-if="domain.premium" :class="{ dark: inCart }" />

  <div
    key="domain"
    :props="props"
    class="grid-item-domain ws-text-primary q-mb-xs"
  >
    <span class="domain-name">{{ domain.name | rmTld(domain.tld)
    }}<span class="tld text-bold">.{{ domain.tld }} </span></span>
  </div>
</div>
